import ApplicationController from './application_controller'
import { clearExceptCurrent } from '../../shared/helpers/recently_viewed_helpers';

export default class RecentlyViewedController extends ApplicationController {
  static values = {
    designId: Number,
    canvasId: Number,
  }

  clearAll() {
    clearExceptCurrent(this.designIdValue, this.canvasIdValue);
    // Hide the recently viewed section after clearing
    this.element.style.display = 'none';
  }
}
